import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../../constants/colors";
import { BackToTopPageButton } from "../../molecules/BackToTopPageButton";
import { FAQItem } from "../../molecules/FAQItem";

export const FAQ: React.FC = () => {
  return (
    <Container>
      <TitleWrapper>よくあるご質問</TitleWrapper>
      <FAQItemContainer>
        <FAQItem
          question="「Joyfull ネット注文」とは、どのようなサイトですか？"
          answer="PC・スマートフォンから会員登録をしていただくと、ジョイフルの店舗でのお持ちかえりメニューを注文していただけます。"
        />
        <FAQItem
          question="24時間注文できますか？"
          answer={`店舗によって異なります。\nご利用店舗を検索していただき、ご確認ください。`}
        />
        <FAQItem
          question="どんな商品が注文できますか？"
          answer={`お持ちかえりメニューは店舗によって異なります。\nご利用店舗を検索していただき、ご確認ください。`}
        />
        <FAQItem
          question="登録料や利用料はかかりますか？"
          answer="サイトの登録料や利用料はいただいておりません。ただしサイトの利用やメール受信等に必要な通信料はお客様のご負担となります。"
        />
        <FAQItem
          question="電話での注文はできますか？"
          answer="電話のご注文は承っておりません。"
        />
        <FAQItem
          question="注文をキャンセルできますか？"
          answer="マイページからキャンセルできます。店舗の受付状況によっては、キャンセルボタンが表示されなくなりますので、その場合には、恐れ入りますが、ご利用の店舗まで直接お電話にてお問い合わせください。"
        />
        <FAQItem
          question="注文した時間に遅れそうです。"
          answer="恐れ入りますが、ご利用の店舗まで直接お電話にてお問い合わせください。"
        />
        <FAQItem
          question="お持ちかえりに身分証明書は必要ですか？"
          answer="ご利用の店舗にて、ご注文時のお名前と注文IDをお伝えいただければ結構です。"
        />
        <FAQItem
          question="パスワードを忘れてしまいました。"
          answer="ログイン画面下部の「パスワードをお忘れの方はこちら」をクリックしてください。 パスワードを再設定していただくことが可能です。"
        />
        <FAQItem
          question="1か月先の注文はできますか？"
          answer="ご注文日より6日後までの注文が可能です。"
        />
        <FAQItem
          question="新規会員登録や注文内容確認メールが届かないのですが？"
          answer={`ドメイン指定受信をご利用のお客様は「@joyfull-weborder.jp」を追加してメールが受信できるようにしてください。また、登録したメールアドレスに誤りがないか、メールボックスが容量一杯になっていないか、迷惑メールフォルダに振り分けられてしまっていないか、併せて、ご確認ください。\n 上記のご対応を頂いてもメールが届かない場合、Webメール（GmailやYahoo!メールなど）の使用をご検討ください。`}
        />
        <FAQItem
          question="支払方法は現金だけですか？"
          answer={`クレジットカード・デビットカード・プリペイドカード・QRコード決済・電子マネー・ジェフグルメカードをお使いいただけます。そのほか、ジョイフル優待券・株主様ご優待カードがご利用いただけます。\n※店舗により注文できる時間が異なります。`}
        />
        <FAQItem
          question="メールに書かれているURLがクリックできない。"
          answer={`ご使用のメールソフトによっては、メールに記載されているURLがクリックできないことがあります。\n その場合は、URLをコピーして、ブラウザに直接貼り付けてアクセスしてください。`}
        />
      </FAQItemContainer>

      <ButtonWrapper>
        <BackToTopPageButton />
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  padding: 0 16px 47px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const TitleWrapper = styled.p`
  font-size: 20px;
  font-weight: 500;
  padding: 43px 0 30px 0;
  display: flex;
  justify-content: center;
  line-height: 1;
  font-family: "Hiragino Sans";
`;

const FAQItemContainer = styled.div`
  margin-bottom: 43px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  button {
    height: auto;
    line-height: 1;
    font-weight: bold;
  }
`;
